import { render, staticRenderFns } from "./SelectPackageCard.vue?vue&type=template&id=0657df5b&"
import script from "./SelectPackageCard.vue?vue&type=script&lang=js&"
export * from "./SelectPackageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports